import React, { useState, useEffect } from 'react';
import './pro-affiliate.css';
import { useLanguage } from '../contexts/LanguageContext';
import resmailLogo from '../assets/resmail.png';
import aboutLogo from '../assets/lamp.svg';
import affiliateImage from '../assets/affiliate/aff-no.svg';
import affiliateImg from '../assets/affiliate-img.svg';
import Pro from '../assets/pro.svg';
import Table from './table';
import './table.css';
import aff1 from '../assets/affiliate/aff1.svg';
import aff2 from '../assets/affiliate/aff2.svg';
import aff3 from '../assets/affiliate/aff3.svg';
import aff4 from '../assets/affiliate/aff4.svg';
import aff5 from '../assets/affiliate/aff5.1.svg';
import aff6 from '../assets/affiliate/aff6.svg';
import aff7 from '../assets/affiliate/aff7.1.svg';
import aff8 from '../assets/affiliate/aff8.1.svg';
import bubbleImage from '../assets/bubble.svg';

function ProAffiliate() {
    const { isArabic, setLanguage } = useLanguage();
    const [searchQuery, setSearchQuery] = useState('');

    useEffect(() => {
        setLanguage('en');
    }, [setLanguage]);

    const handleSearch = (e) => {
        e.preventDefault();
        // Handle search logic here
        console.log('Searching for:', searchQuery);
    };

    return (
        <div className="affiliate-page">
            <section className="affiliate-hero">
                <div className="affiliate-hero-container">
                    <div className="affiliate-hero-left">
                        {/* <div className="affiliate-search-wrapper">
                            <form onSubmit={handleSearch} className="affiliate-search-form">
                                <input
                                    type="text"
                                    placeholder={isArabic ? "ابحث عن الشركات التابعة..." : "Search for affiliates..."}
                                    value={searchQuery}
                                    onChange={(e) => setSearchQuery(e.target.value)}
                                    className="affiliate-search-input"
                                />
                                <button type="submit" className="affiliate-search-button">
                                    {isArabic ? "بحث" : "Search"}
                                </button>
                            </form>
                        </div> */}
                        <div className="affiliate-content">
                            <Table type="pro" title="PROMOTERS" pointsLabel="Commission 10%" />
                        </div>
                    </div>
                    <div className="affiliate-hero-right">
                        <img src={affiliateImage} alt="Affiliate" className="affiliate-hero-image" />
                    </div>
                </div>
            </section>
            <section className="payout-section">
                <div className="payout-image-container">
                    <img src={Pro} alt="Commission Payout" />
                </div>
                <div className="payout-content">
                    <h2 className="payout-main-text">COMMISSION WILL BE PAID OUT</h2>
                    <p className="payout-sub-text">Within <span className='yellow-text'>14 business days</span> after the event</p>
                </div>
            </section>

        </div>
    );
}

export default ProAffiliate;
